import "angular";
import DocsController from "./DocsController";
import DocsLinksService from "./DocsLinksService";
import DocsStates from "./DocsStates";

const DocsModule = angular
    .module("DocsModule", ["ui.router"])
    .controller("DocsController", DocsController)
    .service("DocsLinksService", DocsLinksService)
    .config(DocsStates);
export default DocsModule;
